<section class="aca-mig__card aca-mig__cardpad">
  <!-- stepper -->
  <div class="aca-mig__steps">
    <span
      class="aca-mig__step"
      *ngFor="let key of stepKeys; trackBy: trackByStep; let i = index"
      [class.aca-mig__step--on]="step() === i"
      [class.aca-mig__step--done]="i < step()"
    >
      <span class="aca-mig__stepnum">{{ i + 1 }}</span>
      {{ key | translate }}
    </span>
  </div>

  <!-- ── 1. Source ─────────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 0">
    <label class="aca-mig__field">
      <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_NAME' | translate }} *</span>
      <input class="aca-mig__input" type="text" [(ngModel)]="job.name" [placeholder]="'DMS.MIGRATION.PH_NAME' | translate" />
    </label>

    <ng-container *ngFor="let cat of categories">
      <h4 class="aca-mig__conncat">{{ cat.titleKey | translate }}</h4>
      <div class="aca-mig__conngrid">
        <button
          type="button"
          class="aca-mig__conncard"
          *ngFor="let c of connectorsOf(cat.id); trackBy: trackByConn"
          [class.aca-mig__conncard--on]="job.sourceConnector === c.id"
          [disabled]="c.availability !== 'available'"
          (click)="pickConnector(c)"
        >
          <span class="aca-mig__connicon"
            ><mat-icon>{{ c.icon }}</mat-icon></span
          >
          <span>
            <span class="aca-mig__connname">{{ c.titleKey | translate }}</span>
            <span class="aca-mig__conndesc">{{ c.descKey | translate }}</span>
            <span class="aca-mig__connstatus">
              <span
                class="aca-mig__chip"
                [class.aca-mig__chip--ok]="c.availability === 'available' && !engineUnsupported(c)"
                [class.aca-mig__chip--warn]="engineUnsupported(c)"
              >
                {{
                  (engineUnsupported(c)
                    ? 'DMS.MIGRATION.ENGINE_UNSUPPORTED'
                    : c.availability === 'available'
                      ? 'DMS.MIGRATION.CONN_AVAILABLE'
                      : 'DMS.MIGRATION.CONN_COMING_SOON'
                  ) | translate
                }}
              </span>
            </span>
          </span>
        </button>
      </div>
    </ng-container>

    <!-- capability statement for the picked connector -->
    <ng-container *ngIf="connector as conn">
      <h4 class="aca-mig__conncat">{{ 'DMS.MIGRATION.CAP_TITLE' | translate }}</h4>
      <div class="aca-mig__tablewrap">
        <table class="aca-mig__table">
          <tbody>
            <tr class="aca-mig__row" *ngFor="let cap of conn.capabilities; trackBy: trackByRow">
              <td class="aca-mig__td">{{ 'DMS.MIGRATION.CAP_' + cap.key.toUpperCase() | translate }}</td>
              <td class="aca-mig__td">
                <span
                  class="aca-mig__chip"
                  [ngClass]="cap.level === 'yes' ? 'aca-mig__chip--ok' : cap.level === 'no' ? 'aca-mig__chip--fail' : 'aca-mig__chip--warn'"
                >
                  {{ 'DMS.MIGRATION.CAPLEVEL_' + cap.level.toUpperCase() | translate }}
                </span>
                <span class="aca-mig__hint" *ngIf="cap.noteKey"> {{ cap.noteKey | translate }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- migration mode, only meaningful for alfresco sources -->
      <div class="aca-mig__field" *ngIf="conn.id === 'alfresco'" style="margin-top: 14px">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_MODE' | translate }}</span>
        <label style="display: flex; gap: 8px; font-size: 12.5px; align-items: flex-start">
          <input type="radio" name="migmode" value="standard" [(ngModel)]="job.mode" />
          <span>
            <strong>{{ 'DMS.MIGRATION.MODE_STANDARD' | translate }}</strong
            ><br />
            <span class="aca-mig__hint">{{ 'DMS.MIGRATION.MODE_STANDARD_DESC' | translate }}</span>
          </span>
        </label>
        <label style="display: flex; gap: 8px; font-size: 12.5px; align-items: flex-start">
          <input type="radio" name="migmode" value="full-fidelity" [(ngModel)]="job.mode" />
          <span>
            <strong>{{ 'DMS.MIGRATION.MODE_FULL' | translate }}</strong
            ><br />
            <span class="aca-mig__hint">{{ 'DMS.MIGRATION.MODE_FULL_DESC' | translate }}</span>
          </span>
        </label>
        <p class="aca-mig__notice" *ngIf="job.mode === 'full-fidelity'">
          <mat-icon>warning_amber</mat-icon>
          <span>{{ 'DMS.MIGRATION.MODE_FULL_WARN' | translate }}</span>
        </p>
      </div>
    </ng-container>
  </ng-container>

  <!-- ── 2. Connection ─────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 1">
    <div class="aca-mig__field">
      <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_CONNECTION' | translate }}</span>
      <div style="display: flex; gap: 10px; align-items: center">
        <select
          class="aca-mig__select"
          style="flex: 1"
          [(ngModel)]="job.sourceConnectionId"
          (ngModelChange)="onConnectionChange()"
          [attr.aria-label]="'DMS.MIGRATION.F_CONNECTION' | translate"
        >
          <option [ngValue]="undefined">{{ 'DMS.MIGRATION.PICK_CONNECTION' | translate }}</option>
          <option *ngFor="let c of connectionsForConnector()" [ngValue]="c.id">{{ c.name || c.id }}</option>
        </select>
        <button type="button" class="aca-mig__btn" (click)="addConnection()">
          <mat-icon>add</mat-icon>{{ 'DMS.MIGRATION.ADD_CONNECTION' | translate }}
        </button>
      </div>
      <span class="aca-mig__hint">{{ 'DMS.MIGRATION.CONNECTION_HINT' | translate }}</span>
      <!-- a connection saved for a different connector can never serve this
           job, so the filter is right — say so rather than look broken -->
      <span class="aca-mig__hint" *ngIf="!connectionsForConnector().length">
        {{ (connections().length ? 'DMS.MIGRATION.CONN_OTHER_TYPES' : 'DMS.MIGRATION.CONN_NONE_FOR_TYPE') | translate }}
      </span>
    </div>

    <p class="aca-mig__notice aca-mig__notice--info" *ngIf="api.available() !== true">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.BACKEND_TEST_NOTE' | translate }}</span>
    </p>
  </ng-container>

  <!-- ── 3. Discovery ──────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 2">
    <p class="aca-mig__notice" *ngIf="api.available() !== true">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.DISCOVERY_UNAVAILABLE' | translate }}</span>
    </p>
    <p class="aca-mig__hint" *ngIf="api.available() !== true">{{ 'DMS.MIGRATION.DISCOVERY_SKIPPABLE' | translate }}</p>

    <ng-container *ngIf="api.available() === true">
      <p class="aca-mig__notice aca-mig__notice--info" *ngIf="!job.sourceConnectionId">
        <mat-icon>info_outline</mat-icon>
        <span>{{ 'DMS.MIGRATION.NO_CONN' | translate }}</span>
      </p>

      <p class="aca-mig__hint" *ngIf="discovering()">{{ 'DMS.MIGRATION.DISCOVERY_SCANNING' | translate }}</p>

      <!-- populated only when the engine answers; never fabricated -->
      <ng-container *ngIf="discovery() as d">
        <p class="aca-mig__notice" *ngIf="d.failed">
          <mat-icon>error_outline</mat-icon>
          <span
            >{{ 'DMS.MIGRATION.DISCOVERY_FAIL' | translate }}<ng-container *ngIf="d.detail"> — {{ d.detail }}</ng-container></span
          >
        </p>
        <ng-container *ngIf="!d.failed">
          <dl class="aca-mig__kv">
            <dt>{{ 'DMS.MIGRATION.DISC_FOLDERS' | translate }}</dt>
            <dd>{{ d.folders ?? '—' }}</dd>
            <dt>{{ 'DMS.MIGRATION.DISC_DOCUMENTS' | translate }}</dt>
            <dd>{{ d.documents ?? '—' }}</dd>
            <dt>{{ 'DMS.MIGRATION.DISC_SIZE' | translate }}</dt>
            <dd>{{ d.bytes ?? 0 | number }}</dd>
            <dt>{{ 'DMS.MIGRATION.DISC_ROOTS' | translate }}</dt>
            <dd>
              <span class="aca-mig__mono" *ngFor="let r of d.roots ?? []; trackBy: trackByRow">{{ r }}</span>
              <span *ngIf="!(d.roots ?? []).length">—</span>
            </dd>
          </dl>
          <p class="aca-mig__notice aca-mig__notice--info" *ngIf="d.truncated">
            <mat-icon>warning_amber</mat-icon>
            <span>{{ 'DMS.MIGRATION.DISC_TRUNCATED' | translate }}</span>
          </p>
        </ng-container>
      </ng-container>

      <div *ngIf="job.sourceConnectionId && !discovering()">
        <button type="button" class="aca-mig__btn" (click)="runDiscovery()">
          <mat-icon>refresh</mat-icon>{{ 'DMS.MIGRATION.DISC_RESCAN' | translate }}
        </button>
      </div>
    </ng-container>
  </ng-container>

  <!-- ── 4. Select data ────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 3">
    <!-- source tree picker — only the engine can walk the source -->
    <div class="aca-mig__field" *ngIf="api.available() === true && job.sourceConnectionId">
      <span class="aca-mig__label">{{ 'DMS.MIGRATION.BROWSE_TITLE' | translate }}</span>
      <div class="aca-mig__toolbar" style="margin-bottom: 4px">
        <button
          type="button"
          class="aca-mig__iconbtn"
          [disabled]="!browsePath() || browsing()"
          [title]="'DMS.MIGRATION.BROWSE_UP' | translate"
          (click)="browseUp()"
        >
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <span class="aca-mig__mono">/{{ browsePath() }}</span>
        <span class="aca-mig__spacer"></span>
        <button type="button" class="aca-mig__iconbtn" [disabled]="browsing()" (click)="browse(browsePath())">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      <div class="aca-mig__tablewrap" *ngIf="browseEntries().length">
        <table class="aca-mig__table">
          <tbody>
            <tr class="aca-mig__row" *ngFor="let e of browseEntries(); trackBy: trackByRow">
              <td class="aca-mig__td" style="width: 30px">
                <mat-icon style="font-size: 18px; vertical-align: middle">{{ e.folder ? 'folder' : 'description' }}</mat-icon>
              </td>
              <td class="aca-mig__td aca-mig__mono">{{ e.name }}</td>
              <td class="aca-mig__td" style="width: 110px; text-align: right">
                <button type="button" class="aca-mig__btn aca-mig__btn--sm" *ngIf="e.folder" (click)="browse(e.path)">
                  {{ 'DMS.MIGRATION.BROWSE_OPEN' | translate }}
                </button>
                <button
                  type="button"
                  class="aca-mig__iconbtn"
                  [disabled]="job.selection.paths.includes(e.path)"
                  [title]="'DMS.MIGRATION.ADD_PATH' | translate"
                  (click)="addBrowsePath(e)"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="aca-mig__hint" *ngIf="browsing()">{{ 'DMS.MIGRATION.BROWSE_LOADING' | translate }}</p>
      <p class="aca-mig__notice" *ngIf="browseFailed()">
        <mat-icon>error_outline</mat-icon>
        <span>{{ 'DMS.MIGRATION.BROWSE_FAIL' | translate }}</span>
      </p>
      <p class="aca-mig__hint" *ngIf="!browsing() && !browseFailed() && !browseEntries().length">
        {{ 'DMS.MIGRATION.BROWSE_EMPTY' | translate }}
      </p>
    </div>

    <div class="aca-mig__field">
      <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_PATHS' | translate }}</span>
      <div style="display: flex; gap: 10px">
        <input
          class="aca-mig__input"
          style="flex: 1"
          type="text"
          [(ngModel)]="newPath"
          [placeholder]="'DMS.MIGRATION.PH_PATH' | translate"
          [attr.aria-label]="'DMS.MIGRATION.F_PATHS' | translate"
          (keydown.enter)="addPath()"
        />
        <button type="button" class="aca-mig__btn" [disabled]="!newPath.trim()" (click)="addPath()">
          {{ 'DMS.MIGRATION.ADD_PATH' | translate }}
        </button>
      </div>
      <span class="aca-mig__hint">{{ 'DMS.MIGRATION.PATHS_HINT' | translate }}</span>
    </div>

    <div class="aca-mig__tablewrap" *ngIf="job.selection.paths.length">
      <table class="aca-mig__table">
        <tbody>
          <tr class="aca-mig__row" *ngFor="let p of job.selection.paths; trackBy: trackByRow">
            <td class="aca-mig__td aca-mig__mono">{{ p }}</td>
            <td class="aca-mig__td" style="width: 40px; text-align: right">
              <button type="button" class="aca-mig__iconbtn" (click)="removePath(p)"><mat-icon>close</mat-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="aca-mig__grid2" style="margin-top: 12px">
      <label style="display: flex; gap: 8px; font-size: 12.5px">
        <input type="checkbox" [(ngModel)]="job.selection.includeSubfolders" />
        {{ 'DMS.MIGRATION.INC_SUBFOLDERS' | translate }}
      </label>
      <label style="display: flex; gap: 8px; font-size: 12.5px">
        <input type="checkbox" [(ngModel)]="job.selection.includeVersions" />
        {{ 'DMS.MIGRATION.INC_VERSIONS' | translate }}
      </label>
      <label style="display: flex; gap: 8px; font-size: 12.5px">
        <input type="checkbox" [(ngModel)]="job.selection.includePermissions" />
        {{ 'DMS.MIGRATION.INC_PERMISSIONS' | translate }}
      </label>
      <label style="display: flex; gap: 8px; font-size: 12.5px">
        <input type="checkbox" [(ngModel)]="job.selection.includeMetadata" />
        {{ 'DMS.MIGRATION.INC_METADATA' | translate }}
      </label>
    </div>

    <p class="aca-mig__hint" style="margin-top: 10px">
      {{ 'DMS.MIGRATION.SELECTED_COUNT' | translate: { count: job.selection.paths.length } }}
    </p>
  </ng-container>

  <!-- ── 5. Mapping ────────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 4">
    <div class="aca-mig__tabs" style="margin-bottom: 12px">
      <button
        type="button"
        class="aca-mig__tab"
        *ngFor="let t of ['folders', 'types', 'metadata', 'users', 'permissions']"
        [class.aca-mig__tab--on]="mapTable === t"
        (click)="mapTable = $any(t)"
      >
        {{ 'DMS.MIGRATION.MAP_' + t.toUpperCase() | translate }}
      </button>
    </div>

    <div style="display: flex; gap: 10px; margin-bottom: 12px">
      <input
        class="aca-mig__input"
        style="flex: 1"
        type="text"
        [(ngModel)]="newMapSource"
        [placeholder]="'DMS.MIGRATION.PH_MAP_SOURCE' | translate"
        [attr.aria-label]="'DMS.MIGRATION.PH_MAP_SOURCE' | translate"
      />
      <span style="align-self: center">→</span>
      <input
        class="aca-mig__input"
        style="flex: 1"
        type="text"
        [(ngModel)]="newMapTarget"
        [placeholder]="'DMS.MIGRATION.PH_MAP_TARGET' | translate"
        [attr.aria-label]="'DMS.MIGRATION.PH_MAP_TARGET' | translate"
      />
      <button type="button" class="aca-mig__btn" [disabled]="!newMapSource.trim() || !newMapTarget.trim()" (click)="addMappingRow()">
        {{ 'DMS.MIGRATION.MAP_ADD' | translate }}
      </button>
    </div>

    <div class="aca-mig__empty" *ngIf="!job.mapping[mapTable].length">
      <mat-icon>alt_route</mat-icon>
      <div>{{ 'DMS.MIGRATION.MAP_EMPTY' | translate }}</div>
    </div>

    <div class="aca-mig__tablewrap" *ngIf="job.mapping[mapTable].length">
      <table class="aca-mig__table">
        <thead>
          <tr>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_SOURCE_FIELD' | translate }}</th>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DEST_FIELD' | translate }}</th>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_ACTION' | translate }}</th>
            <th class="aca-mig__th" style="width: 40px"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="aca-mig__row" *ngFor="let row of job.mapping[mapTable]; let i = index; trackBy: trackByRow">
            <td class="aca-mig__td aca-mig__mono">{{ row.source }}</td>
            <td class="aca-mig__td aca-mig__mono">{{ row.target }}</td>
            <td class="aca-mig__td">
              <select class="aca-mig__select" style="height: 28px" [ngModel]="row.action" (ngModelChange)="setRowAction(row, $event)">
                <option value="map">{{ 'DMS.MIGRATION.MAP_MAP' | translate }}</option>
                <option value="ignore">{{ 'DMS.MIGRATION.MAP_IGNORE' | translate }}</option>
                <option value="default">{{ 'DMS.MIGRATION.MAP_DEFAULT' | translate }}</option>
                <option value="review">{{ 'DMS.MIGRATION.MAP_REVIEW' | translate }}</option>
              </select>
            </td>
            <td class="aca-mig__td">
              <button type="button" class="aca-mig__iconbtn" (click)="removeMappingRow(mapTable, i)"><mat-icon>close</mat-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- ── 6. Validation ─────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 5">
    <div class="aca-mig__tablewrap">
      <table class="aca-mig__table">
        <tbody>
          <tr class="aca-mig__row" *ngFor="let r of validationResults(); trackBy: trackByRow">
            <td class="aca-mig__td" style="width: 120px">
              <span
                class="aca-mig__chip"
                [ngClass]="r.level === 'pass' ? 'aca-mig__chip--ok' : r.level === 'warn' ? 'aca-mig__chip--warn' : 'aca-mig__chip--fail'"
              >
                {{ 'DMS.MIGRATION.VLEVEL_' + r.level.toUpperCase() | translate }}
              </span>
            </td>
            <td class="aca-mig__td">{{ r.labelKey | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="aca-mig__notice aca-mig__notice--info" style="margin-top: 12px">
      <mat-icon>info_outline</mat-icon>
      <span>{{ 'DMS.MIGRATION.V_SERVER_NOTE' | translate }}</span>
    </p>
  </ng-container>

  <!-- ── 7. Dry run ────────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 6">
    <p class="aca-mig__notice" *ngIf="api.available() !== true">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.DRYRUN_UNAVAILABLE' | translate }}</span>
    </p>
    <p class="aca-mig__hint">{{ 'DMS.MIGRATION.DRYRUN_DESC' | translate }}</p>

    <ng-container *ngIf="api.available() === true">
      <p class="aca-mig__hint" *ngIf="dryRunning()">{{ 'DMS.MIGRATION.DRYRUN_RUNNING' | translate }}</p>

      <ng-container *ngIf="dryResult() as r">
        <p class="aca-mig__notice" *ngIf="r.failed">
          <mat-icon>error_outline</mat-icon>
          <span
            >{{ 'DMS.MIGRATION.DRYRUN_FAIL' | translate }}<ng-container *ngIf="r.detail"> — {{ r.detail }}</ng-container></span
          >
        </p>
        <ng-container *ngIf="!r.failed">
          <dl class="aca-mig__kv">
            <dt>{{ 'DMS.MIGRATION.DISC_FOLDERS' | translate }}</dt>
            <dd>{{ r.statistics?.folders ?? '—' }}</dd>
            <dt>{{ 'DMS.MIGRATION.DISC_DOCUMENTS' | translate }}</dt>
            <dd>{{ r.statistics?.documents ?? '—' }}</dd>
            <dt>{{ 'DMS.MIGRATION.DISC_SIZE' | translate }}</dt>
            <dd>{{ r.statistics?.bytes ?? 0 | number }}</dd>
            <dt>{{ 'DMS.MIGRATION.DRYRUN_DUPLICATES' | translate }}</dt>
            <dd>{{ r.duplicates ?? 0 }}</dd>
            <dt>{{ 'DMS.MIGRATION.DRYRUN_DEST' | translate }}</dt>
            <dd class="aca-mig__mono">/Company Home/{{ r.destinationPath || 'Migrated' }}</dd>
          </dl>
          <div class="aca-mig__tablewrap" *ngIf="(r.sample ?? []).length" style="margin-top: 10px">
            <table class="aca-mig__table">
              <thead>
                <tr>
                  <th class="aca-mig__th">{{ 'DMS.MIGRATION.DRYRUN_SAMPLE' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="aca-mig__row" *ngFor="let p of r.sample; trackBy: trackByRow">
                  <td class="aca-mig__td aca-mig__mono">{{ p }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="aca-mig__tablewrap" *ngIf="(r.duplicatePaths ?? []).length" style="margin-top: 10px">
            <table class="aca-mig__table">
              <thead>
                <tr>
                  <th class="aca-mig__th">{{ 'DMS.MIGRATION.DRYRUN_DUPPATHS' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="aca-mig__row" *ngFor="let p of r.duplicatePaths; trackBy: trackByRow">
                  <td class="aca-mig__td aca-mig__mono">{{ p }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>

      <div style="margin-top: 12px">
        <button type="button" class="aca-mig__btn" [disabled]="dryRunning() || !job.selection.paths.length" (click)="rerunDryRun()">
          <mat-icon>replay</mat-icon>{{ 'DMS.MIGRATION.DRYRUN_AGAIN' | translate }}
        </button>
      </div>
    </ng-container>
  </ng-container>

  <!-- ── 8. Migration ──────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 7">
    <label class="aca-mig__field" style="margin-bottom: 14px">
      <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_DESTPATH' | translate }}</span>
      <span style="display: flex; gap: 8px; align-items: center">
        <input
          class="aca-mig__input"
          type="text"
          style="flex: 1"
          [(ngModel)]="job.destinationPath"
          [placeholder]="'DMS.MIGRATION.PH_DESTPATH' | translate"
        />
        <button type="button" class="aca-mig__btn aca-mig__btn--sm" (click)="browseDestination()">
          <mat-icon>folder_open</mat-icon>{{ 'DMS.MIGRATION.BROWSE' | translate }}
        </button>
      </span>
      <span class="aca-mig__hint">{{ 'DMS.MIGRATION.DESTPATH_HINT' | translate }}</span>
    </label>

    <dl class="aca-mig__kv">
      <dt>{{ 'DMS.MIGRATION.F_NAME' | translate }}</dt>
      <dd>{{ job.name || '—' }}</dd>
      <dt>{{ 'DMS.MIGRATION.COL_SOURCE' | translate }}</dt>
      <dd>{{ connector ? (connector.titleKey | translate) : '—' }}</dd>
      <dt>{{ 'DMS.MIGRATION.COL_DEST' | translate }}</dt>
      <dd>{{ 'DMS.MIGRATION.DEST_CURRENT' | translate }} — {{ job.destinationPath || 'Migrated' }}</dd>
      <dt>{{ 'DMS.MIGRATION.F_MODE' | translate }}</dt>
      <dd>{{ (job.mode === 'full-fidelity' ? 'DMS.MIGRATION.MODE_FULL' : 'DMS.MIGRATION.MODE_STANDARD') | translate }}</dd>
      <dt>{{ 'DMS.MIGRATION.F_PATHS' | translate }}</dt>
      <dd>{{ job.selection.paths.length }}</dd>
      <dt>{{ 'DMS.MIGRATION.F_DUPPOLICY' | translate }}</dt>
      <dd>{{ dupLabel(job.duplicatePolicy) }}</dd>
      <ng-container *ngIf="job.schedule?.enabled">
        <dt>{{ 'DMS.MIGRATION.F_SCHEDULE' | translate }}</dt>
        <dd class="aca-mig__mono">{{ job.schedule.cron }} ({{ job.schedule.timezone }})</dd>
      </ng-container>
    </dl>

    <label class="aca-mig__field" style="margin-top: 12px">
      <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_DUPPOLICY' | translate }}</span>
      <select class="aca-mig__select" [(ngModel)]="job.duplicatePolicy">
        <option value="skip">{{ 'DMS.MIGRATION.DUP_SKIP' | translate }}</option>
        <option value="new">{{ 'DMS.MIGRATION.DUP_NEW' | translate }}</option>
        <option value="new-version">{{ 'DMS.MIGRATION.DUP_NEW_VERSION' | translate }}</option>
        <option value="review">{{ 'DMS.MIGRATION.DUP_REVIEW' | translate }}</option>
        <option value="replace">{{ 'DMS.MIGRATION.DUP_REPLACE' | translate }}</option>
      </select>
      <span class="aca-mig__hint">{{ 'DMS.MIGRATION.DUP_HINT' | translate }}</span>
    </label>

    <label style="display: flex; gap: 8px; font-size: 12.5px">
      <input type="checkbox" [(ngModel)]="job.checksumVerification" />
      {{ 'DMS.MIGRATION.F_CHECKSUM' | translate }}
    </label>

    <label style="display: flex; gap: 8px; font-size: 12.5px; margin-top: 10px">
      <input type="checkbox" [(ngModel)]="job.schedule.enabled" />
      {{ 'DMS.MIGRATION.SCHED_ON' | translate }}
    </label>
    <ng-container *ngIf="job.schedule?.enabled">
      <label class="aca-mig__field" style="margin-top: 8px">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_CRON' | translate }}</span>
        <input class="aca-mig__input" type="text" [(ngModel)]="job.schedule.cron" placeholder="0 0 2 * * *" />
        <span class="aca-mig__hint">{{ 'DMS.MIGRATION.CRON_HINT' | translate }}</span>
      </label>
      <label class="aca-mig__field">
        <span class="aca-mig__label">{{ 'DMS.MIGRATION.F_TIMEZONE' | translate }}</span>
        <input class="aca-mig__input" type="text" [(ngModel)]="job.schedule.timezone" placeholder="Asia/Bangkok" />
      </label>
      <p class="aca-mig__hint">{{ 'DMS.MIGRATION.SCHED_HINT' | translate }}</p>
    </ng-container>

    <p class="aca-mig__notice" *ngIf="api.available() !== true" style="margin-top: 12px">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.START_UNAVAILABLE' | translate }}</span>
    </p>
  </ng-container>

  <!-- ── 9. Verification ───────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 8">
    <p class="aca-mig__notice" *ngIf="api.available() !== true">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.VERIFY_UNAVAILABLE' | translate }}</span>
    </p>
    <p class="aca-mig__hint">{{ 'DMS.MIGRATION.VERIFY_DESC' | translate }}</p>

    <!-- the live run the engine is tracking -->
    <ng-container *ngIf="liveState() as s">
      <dl class="aca-mig__kv">
        <dt>{{ 'DMS.MIGRATION.COL_STATUS' | translate }}</dt>
        <dd>
          <span class="aca-mig__chip" [ngClass]="statusClass(s.status)">
            {{ 'DMS.MIGRATION.ST_' + (s.status || 'running').toUpperCase().replace('-', '_') | translate }}
          </span>
        </dd>
        <dt>{{ 'DMS.MIGRATION.COL_PROGRESS' | translate }}</dt>
        <dd>{{ s.totalItems ?? '—' }}</dd>
        <dt>{{ 'DMS.MIGRATION.VERIFY_ERRORS' | translate }}</dt>
        <dd>{{ s.errors ?? 0 }}</dd>
        <dt>{{ 'DMS.MIGRATION.COL_STARTED' | translate }}</dt>
        <dd>{{ s.startedAt | date: 'dd/MM/yyyy HH:mm' }}</dd>
        <dt *ngIf="s.finishedAt">{{ 'DMS.MIGRATION.COL_COMPLETED' | translate }}</dt>
        <dd *ngIf="s.finishedAt">{{ s.finishedAt | date: 'dd/MM/yyyy HH:mm' }}</dd>
      </dl>
      <p class="aca-mig__notice" *ngIf="s.error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ s.error }}</span>
      </p>
    </ng-container>

    <!-- the run ended before the engine could be polled — the job file's word is final -->
    <ng-container *ngIf="!liveState() && job.status === 'running'">
      <p class="aca-mig__hint">{{ 'DMS.MIGRATION.VERIFY_WAITING' | translate }}</p>
    </ng-container>
    <ng-container *ngIf="!liveState() && job.id && job.status !== 'running'">
      <dl class="aca-mig__kv">
        <dt>{{ 'DMS.MIGRATION.COL_STATUS' | translate }}</dt>
        <dd>
          <span class="aca-mig__chip" [ngClass]="statusClass(job.status)">{{ statusKey(job.status) | translate }}</span>
        </dd>
      </dl>
    </ng-container>
  </ng-container>

  <!-- ── 10. Complete ──────────────────────────────────────────────────── -->
  <ng-container *ngIf="step() === 9">
    <div class="aca-mig__empty" style="padding: 30px 20px">
      <mat-icon>{{ job.id ? 'check_circle' : 'drafts' }}</mat-icon>
      <div class="aca-mig__emptytitle">
        {{ (job.id ? 'DMS.MIGRATION.COMPLETE_DRAFT' : 'DMS.MIGRATION.COMPLETE_UNSAVED') | translate }}
      </div>
      <div>{{ 'DMS.MIGRATION.COMPLETE_DESC' | translate }}</div>
      <div class="aca-mig__wizgroup" style="margin-top: 8px">
        <button type="button" class="aca-mig__btn" (click)="saveDraft()" *ngIf="!job.id" [disabled]="busy()">
          {{ 'DMS.MIGRATION.SAVE_DRAFT' | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <!-- ── actions ───────────────────────────────────────────────────────── -->
  <div class="aca-mig__wizactions">
    <div class="aca-mig__wizgroup">
      <button type="button" class="aca-mig__btn" [disabled]="step() === 0" (click)="back()">
        {{ 'DMS.MIGRATION.BACK' | translate }}
      </button>
      <button type="button" class="aca-mig__btn" (click)="cancel()">{{ 'DMS.MIGRATION.CANCEL' | translate }}</button>
    </div>
    <div class="aca-mig__wizgroup">
      <button type="button" class="aca-mig__btn" [disabled]="busy()" (click)="saveDraft()">
        {{ 'DMS.MIGRATION.SAVE_DRAFT' | translate }}
      </button>
      <button type="button" class="aca-mig__btn aca-mig__btn--primary" *ngIf="step() !== 7 && step() < 9" [disabled]="!canNext()" (click)="next()">
        {{ 'DMS.MIGRATION.NEXT' | translate }}
      </button>
      <button
        type="button"
        class="aca-mig__btn aca-mig__btn--primary"
        *ngIf="step() === 7"
        [disabled]="api.available() !== true || hasBlockingError() || !job.id || busy()"
        [matTooltip]="
          api.available() !== true ? ('DMS.MIGRATION.NEEDS_BACKEND' | translate) : !job.id ? ('DMS.MIGRATION.SAVE_FIRST' | translate) : ''
        "
        (click)="startMigration()"
      >
        <mat-icon>play_arrow</mat-icon>{{ 'DMS.MIGRATION.START' | translate }}
      </button>
    </div>
  </div>
</section>
